export const enum AppRouteKey {
  HOME = '/dashboard',
  LOGIN = '/login',
  FORGETPASSWORD = '/forget-password',
  CHOOSECOMPANY = '/choose-company',
  NEWPASSWORD = '/new-password',
  COPILOTNEWPASSWORD = '/copilot-new-password',
  PROFILE = '/profile',
  EDITUSERINFORMATION = '/profile/edit-user-information',
  EDITCOMPANYINFO = '/profile/edit-company-info',
  USERS = '/users',
  USERCREATE = '/users/user-create',
  DEMANDS = '/demands',
  CREATEDEMAND = '/demands/create-demand',
  OPERATIONALBILL = '/bills/operational-bill',
  PROBLEMATICBILL = '/bills/problematic-bill',
  OTHERREFLECTION = '/bills/other-reflection',
  FINANCIALBILL = '/bills/financial-bill',
  ADDITIONALSERVICES = '/bills/additional-services',
  KDVRATESMANAGEMENT = '/financial/kdv-rates-management',
  INTERESTMANAGEMENT = '/financial/interest-management',
  INTERESTINFO = '/financial/interest-info',
  CURRENTACCOUNTEXTRACT = '/financial/current-account-extract',
  BALANCECONFIRMATION = '/financial/balance-confirmation',
  ESTIMATEDOVERKMCALCULATION = '/financial/estimated-overkm-calculation',
  ESTIMATEDOVERKMCALCULATIONRESULT = '/financial/estimated-overkm-calculation-result',
  EARLYRETURNPENALTYFEECALCULATION = '/financial/early-return-penalty-fee-calculation',
  EARLYRETURNPENALTYFEECALCULATIONRESULT = '/financial/early-return-penalty-fee-calculation-result',
  DRIVERTRACKING = '/financial/early-return-penalty-fee-calculation/driver-tracking',
  CREDITCARDPAY = '/financial/pay-with-credit-card',
  DRIVERCHANGES = '/fleet-management/driver-changes',
  HGSINFO = '/fleet-management/hgs-info',
  CARDELIVERY = '/fleet-management/car-delivery',
  FLEETINFORMATION = '/fleet-management/fleet-information',
  CARRETURN = '/fleet-management/car-return',
  CARRETURNREQUEST = '/fleet-management/car-return-request',
  DOCUMENTS = '/fleet-management/documents',
  MAINTENANCE = '/service-operation/maintenance',
  MAINTENANCEAPPOINTMENTCREATE = '/service-operation/maintenance/create-maintenance-appointment',
  MAINTENANCEHISTORY = '/service-operation/maintenance-history',
  BREAKDOWN = '/service-operation/breakdown',
  BREAKDOWNAPPOINTMENTCREATE = '/service-operation/breakdown/create-breakdown-appointment',
  BREAKDOWNHISTORY = '/service-operation/breakdown-history',
  TYRE = '/service-operation/tyre',
  TYREDETAİL = '/service-operation/tyre/:id',
  TYREAPPOINTMENTCREATE = '/service-operation/tyre/create-tyre-appointment',
  TYREHISTORY = '/service-operation/tyre-history',
  ACCIDENTALDAMAGE = '/service-operation/accidental-damage',
  ACCIDENTALDAMAGECREATE = '/service-operation/accidental-damage/create-accidental-damage-appointment',
  ACCIDENTALDAMAGEHISTORY = '/service-operation/accidental-damage-history',
  FAQ = '/help/faq',
  NEWOFFER = '/fleet-management/car-delivery/new-offer',
  OBJECTION = '/bills/objection',
  CHANGEPASSWORD = '/profile/change-password',
  GUIDE = '/help/guide',
  FEEDBACK = '/help/feedback',
  HELP_DIGITAL_ASSISTANT = '/help/digital-assistant',
  SUPPORT = '/live-support',
  PROCESSUALDEMANDS = '/processualdemands',
  PROCESSUALDEMANDSDETAİL = '/processualdemands/:id',
  PROCESSUALDEMANDSCREATE = '/processualdemands/create',
  LIVECHAT = '/live',
  FLEETINFORMATIONDETAILPAGE = '/fleet-management/fleet-information/:id',
  ADDITIONALBILLREQ = '/additionalreq',
  OPERATIONALBILLREQ = '/operationalreq',
  OTHERBILLREQ = '/otherbillreq',
  FINANCIALBILLREQ = '/financialbillreq',
  DRIVERVIDEOS = '/help/driver-video',
  OVERDUE_INVOICE = '/overdue-invoice',
  NOTIFICATIONCREATE = '/campaign-notification/create',
  NOTIFICATIONDETAIL = '/campaign-notification/detail',
  USERLISTDETAIL = '/campaign-user-list/detail',
  USERLISTCREATE = '/campaign-user-list/create',
  CAMPAIGNNEWS = '/campaign-news',
  ACTIVATION = '/activation',
  ACTIVATION_SUCCESS = '/activation/success',
  ACTIVATION_FAIL = '/activation/fail',
  REACTIVATION = '/reactivation',
}
